/**
  * WBT-Player übergreifend (WBT-Data laden, Inhalt skalieren, ...)
  * @namespace v3sWbtPlayerApp:wbt
  */

/**
 * Lädt die WBT-Daten und initialisiert die ScormData-API
 * @class service_v3sWbtDataService
 * @memberOf v3sWbtPlayerApp:wbt
 */
angular.module('v3sWbtPlayerApp').factory('v3sWbtDataService', ["v3sWbt", "v3sLoaderService", "v3sScormDataLmsService", "v3sScormDataBrowserService", "v3sI18nService", "v3sContentPath", "$document", "v3sPageService", "v3sLog", function (v3sWbt, v3sLoaderService, v3sScormDataLmsService, v3sScormDataBrowserService, v3sI18nService, v3sContentPath, $document, v3sPageService, v3sLog) {

    var loading = null;
    var wbt = null;
    var scormApi = null;
    var scoId = "";
    var scoNavigationAllowed;
    var closing = false;

    function init(desiredMode, desiredScoId) {
        return load().then(function () {
            v3sLog.debug("Init ScormAdapter...");
            if (v3sScormDataLmsService.selectLmsApiAdapter(desiredMode)) { //LMS
                scoId = !!desiredScoId ? desiredScoId : "";
                scormApi = v3sScormDataLmsService;
            } else { //Local/Webserver
                scormApi = v3sScormDataBrowserService;
            }

            //TODO automatisch in v3sI18nService nach dem Laden abrufen
            v3sI18nService.setLanguage(wbt.language);

            if (!!scoId) {
                return scormApi.load(wbt.getItem(scoId), desiredMode);
            } else {
                return scormApi.load(wbt, desiredMode);
            }
        }).then(function () {
            if (typeof (scoNavigationAllowed) === "undefined") {
                scoNavigationAllowed = !scoId || scormApi.hasSco(scoId);
            }
        });
    }

    function isInitAllowed() {
        return scormApi == null;
    }

    function isScoChangeAllowed(id) {
        return !id || !scoId || id != scoId;
    }

    function load() {
        if (!loading) {
            v3sLog.debug("WbtData is loading...");
            loading = v3sLoaderService('wbtData.js', v3sContentPath).then(function (wbtData) {
                wbt = new v3sWbt(wbtData);
                $document[0].title = wbt.title;
                v3sLog.debug("WbtData is loaded.");
            });
        }
        return loading;
    }

    function close(forced) {
        if (!!scormApi && !closing) {
            v3sLog.debug("WBT/SCO is closing...");
            closing = true;

            //Lernstand vor dem Beenden aktualisieren
            v3sPageService.destroy();

            var testSco = wbt.getTestSco();
            if (!!testSco) {
                testSco.getTest().finish();
            }

            var closed = scormApi.close(forced);
            if (closed) {
                scormApi = null;
                v3sLog.debug("WBT/SCO is closed.");
            }

            closing = false;
        }
    }

    function save() {
        if (!!scormApi) {
            scormApi.save();
        }
    }

    function isMultiSco() { return !!scoId }

    function isLmsMode() { return scormApi === v3sScormDataLmsService }

    function isBrowserMode() { return scormApi === v3sScormDataBrowserService }

    function isScoStatusLoaded(sco) {
        if (isLmsMode() && isMultiSco()) {
            return scormApi.isScoStatusLoaded() || sco === scoId;
        } else {
            return true;
        }
    }

    return {
        init: init,
        load: load,
        close: close,
        save: save,
        getWbt: function () { return wbt; },
        getScormApi: function () { return scormApi; },
        isInitAllowed: isInitAllowed,
        isScoChangeAllowed: isScoChangeAllowed,
        isMultiSco: isMultiSco,
        isLmsMode: isLmsMode,
        isBrowserMode: isBrowserMode,
        isScoNavigationAllowed: function () { return scoNavigationAllowed; },
        isScoStatusLoaded: isScoStatusLoaded,
        reset: function () { if (!!scormApi) scormApi.reset() }
    }
}]);